import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = {
    key: "company-permission-list",
    class: "clearfix"
};
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = {
    key: "new-permission",
    class: "clearfix"
};
const _hoisted_5 = { class: "clearfix" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_9 = { class: "float-end float-start-sm" };
const _hoisted_10 = {
    key: "edit-permission",
    class: "clearfix"
};
const _hoisted_11 = { class: "clearfix" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_15 = { class: "float-end float-start-sm" };
const _hoisted_16 = { class: "clearfix" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_18 = { class: "input-group top_search" };
const _hoisted_19 = { class: "input-group-btn" };
const _hoisted_20 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-8"
};
const _hoisted_21 = { class: "float-end float-start-sm" };
const _hoisted_22 = { class: "col-xs-12 col-sm-12" };
const _hoisted_23 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_24 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_25 = ["onClick"];
const _hoisted_26 = { key: 0 };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { key: 1 };
const _hoisted_29 = { class: "text-center text-uppercase" };
const _hoisted_30 = { key: 0 };
const _hoisted_31 = { class: "data-grid-footer clearfix detached pw100" };
const _hoisted_32 = {
    key: "system-permission-list",
    class: "clearfix"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_select = _resolveComponent("b-form-select");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _component_UserSystemAccessVue = _resolveComponent("UserSystemAccessVue");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CollapsibleForm, null, {
                title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("h2", null, "Company Access", -1 /* CACHED */)
                    ]))]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_b_form_select, {
                                        modelValue: _ctx.companyId,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.companyId) = $event)),
                                        options: _ctx.companies
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ]),
                                _cache[12] || (_cache[12] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_b_form_select, {
                                        modelValue: _ctx.siteId,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.siteId) = $event)),
                                        options: _ctx.filteredSites
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ]),
                                _cache[13] || (_cache[13] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "primary",
                                            onClick: _ctx.add
                                        }, {
                                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                    _createElementVNode("i", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                                    _createElementVNode("span", { class: "hidden-xs" }, " Add", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"]),
                                        _cache[11] || (_cache[11] = _createTextVNode()),
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "outline-secondary",
                                            onClick: _ctx.toggleAccessPanel
                                        }, {
                                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                    _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                    ])
                                ])
                            ])
                        ], 512 /* NEED_PATCH */), [
                            [_vShow, _ctx.addingPermission]
                        ]),
                        _cache[40] || (_cache[40] = _createTextVNode()),
                        _withDirectives(_createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_b_form_select, {
                                        modelValue: _ctx.companyId,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.companyId) = $event)),
                                        options: _ctx.companies
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ]),
                                _cache[17] || (_cache[17] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_b_form_select, {
                                        modelValue: _ctx.siteId,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.siteId) = $event)),
                                        options: _ctx.filteredSites
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ]),
                                _cache[18] || (_cache[18] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "primary",
                                            onClick: _ctx.updatePermission
                                        }, {
                                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                    _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                                    _createElementVNode("span", { class: "hidden-xs" }, " Update", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"]),
                                        _cache[16] || (_cache[16] = _createTextVNode()),
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "outline-secondary",
                                            onClick: _ctx.cancelEdit
                                        }, {
                                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                    _createElementVNode("span", { class: "hidden-xs" }, " Cancel", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                    ])
                                ])
                            ])
                        ], 512 /* NEED_PATCH */), [
                            [_vShow, _ctx.editingPermission]
                        ]),
                        _cache[41] || (_cache[41] = _createTextVNode()),
                        _withDirectives(_createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_b_form_input, {
                                        type: "text",
                                        modelValue: _ctx.query.keywords,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.keywords) = $event)),
                                        modelModifiers: { trim: true },
                                        placeholder: "Search for...",
                                        onKeyup: _withKeys(_ctx.search, ["enter"]),
                                        required: ""
                                    }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_19, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-default",
                                            onClick: _cache[5] || (_cache[5] =
                                                //@ts-ignore
                                                (...args) => (_ctx.search && _ctx.search(...args)))
                                        }, [...(_cache[19] || (_cache[19] = [
                                                _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                            ]))])
                                    ])
                                ])
                            ]),
                            _cache[22] || (_cache[22] = _createTextVNode()),
                            (_ctx.companiesLoaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "primary",
                                            onClick: _ctx.toggleAccessPanel
                                        }, {
                                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                    _createElementVNode("i", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                                    _createElementVNode("span", { class: "hidden-xs" }, " Grant Access", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ], 512 /* NEED_PATCH */), [
                            [_vShow, !_ctx.addingPermission && !_ctx.editingPermission]
                        ]),
                        _cache[42] || (_cache[42] = _createTextVNode()),
                        _withDirectives(_createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("table", _hoisted_24, [
                                    _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", { class: "text-center w40 no-min-width" }),
                                            _createTextVNode(),
                                            _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tCompany\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                            _createTextVNode(),
                                            _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tSite\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                            _createTextVNode(),
                                            _createElementVNode("th", { class: "text-center" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAuthorized Systems\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                            _createTextVNode(),
                                            _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tGranted On\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                        ])
                                    ], -1 /* CACHED */)),
                                    _cache[37] || (_cache[37] = _createTextVNode()),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                onClick: ($event) => (_ctx.selectForEdit(item)),
                                                style: _normalizeStyle({ backgroundColor: _ctx.editingPermission === item ? '#d1ecf1 !important' : '', cursor: 'pointer' })
                                            }, [
                                                _createElementVNode("td", {
                                                    class: "text-center",
                                                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => { }, ["stop"]))
                                                }, [
                                                    _createVNode(_component_b_button_group, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown, {
                                                                variant: "outline-secondary dots",
                                                                size: "sm",
                                                                onClick: ($event) => (_ctx.view(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    (item.whenGrantedAccessToAllSystems == null)
                                                                        ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                                                                            key: 0,
                                                                            onClick: ($event) => (_ctx.view(item))
                                                                        }, {
                                                                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                                                    _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                                    _createTextVNode(" Edit Authorized Systems\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                                ]))]),
                                                                            _: 1 /* STABLE */
                                                                        }, 8 /* PROPS */, ["onClick"]))
                                                                        : _createCommentVNode("v-if", true),
                                                                    _cache[27] || (_cache[27] = _createTextVNode()),
                                                                    _createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.toggleAccessToAllSystems(item))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "fa fa-lock" }, null, -1 /* CACHED */)),
                                                                            _createTextVNode(" " + _toDisplayString(item.whenGrantedAccessToAllSystems == null ? "Grant Access to All" : "Allow to Set Individual Permissions"), 1 /* TEXT */)
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                                                    _createVNode(_component_b_dropdown_divider),
                                                                    _cache[29] || (_cache[29] = _createTextVNode()),
                                                                    _createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.purge(item))
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                                                _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                                _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                            ]))]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["onClick"]),
                                                                    _cache[30] || (_cache[30] = _createTextVNode()),
                                                                    _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.restore(item))
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                                                                _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                                                _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                            ]))]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["onClick"]), [
                                                                        [_vShow, item.whenDeleted]
                                                                    ])
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _cache[31] || (_cache[31] = _createTextVNode()),
                                                _createElementVNode("td", null, [
                                                    (item.whenGrantedAccessToAllSystems == null)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                            _createElementVNode("a", {
                                                                href: "#",
                                                                onClick: _withModifiers(($event) => (_ctx.view(item)), ["stop", "prevent"])
                                                            }, _toDisplayString(item.companyName), 9 /* TEXT, PROPS */, _hoisted_27)
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item.companyName), 1 /* TEXT */))
                                                ]),
                                                _cache[32] || (_cache[32] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(item.siteId ? item.siteName : 'All'), 1 /* TEXT */),
                                                _cache[33] || (_cache[33] = _createTextVNode()),
                                                _createElementVNode("td", _hoisted_29, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass({
                                                            'badge badge-danger': !item.numberOfSystems && !item.whenGrantedAccessToAllSystems,
                                                            'badge badge-success': item.whenGrantedAccessToAllSystems,
                                                            'badge badge-warning': item.numberOfSystems
                                                        })
                                                    }, _toDisplayString(item.whenGrantedAccessToAllSystems ? 'All' : (item.numberOfSystems || 'None')), 3 /* TEXT, CLASS */)
                                                ]),
                                                _cache[34] || (_cache[34] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.getFormattedDate(item.whenCreated)), 1 /* TEXT */)
                                            ], 12 /* STYLE, PROPS */, _hoisted_25));
                                        }), 256 /* UNKEYED_FRAGMENT */))
                                    ]),
                                    _cache[38] || (_cache[38] = _createTextVNode()),
                                    _createElementVNode("tfoot", null, [
                                        (_ctx.noData)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [...(_cache[35] || (_cache[35] = [
                                                    _createElementVNode("td", {
                                                        class: "text-center",
                                                        colspan: "5"
                                                    }, [
                                                        _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                    ], -1 /* CACHED */)
                                                ]))]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ]),
                            _cache[39] || (_cache[39] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_b_pagination, {
                                    class: "float-end",
                                    modelValue: _ctx.query.pageNo,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.query.pageNo) = $event)),
                                    "per-page": _ctx.query.pageSize,
                                    "total-rows": _ctx.data.recordCount,
                                    "hide-ellipsis": true,
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                            ])
                        ], 512 /* NEED_PATCH */), [
                            [_vShow, _ctx.searchAttempted]
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            })
        ], 512 /* NEED_PATCH */), [
            [_vShow, !_ctx.displaySystemPermissions]
        ]),
        _cache[44] || (_cache[44] = _createTextVNode()),
        _withDirectives(_createElementVNode("div", _hoisted_32, [
            _createVNode(_component_UserSystemAccessVue, {
                filter: _ctx.systemAccessFilter,
                onSystemsUpdated: _ctx.reload
            }, null, 8 /* PROPS */, ["filter", "onSystemsUpdated"])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.displaySystemPermissions]
        ])
    ]));
}
